import type { NftMiniature } from "@anaconda/core/nft/types"
import { action, atom } from "@reatom/core"
import { molecule } from "bunshi"
import { NftsToSellScopeReatom } from "./scope.reatom"

export const NftSelectionMoleculeReatom = molecule((mol, scope) => {
  const initialNftsSelection = scope(NftsToSellScopeReatom)

  const selectedNftsAtom = atom<NftMiniature[]>(
    initialNftsSelection,
    "selectedNftsToSell",
  )

  const removeNft = action((nftId: string) => {
    selectedNftsAtom.set(selectedNftsAtom().filter((n) => n.id !== nftId))
  }, "removeNftToSell")

  const addNft = action((nft: NftMiniature) => {
    const alreadyExists = selectedNftsAtom().find((n) => n.id === nft.id)
    if (!alreadyExists) {
      selectedNftsAtom.set([...selectedNftsAtom(), nft])
    }
  }, "addNftToSell")

  const toggleNftSelection = action((nft: NftMiniature) => {
    const selectedNfts = selectedNftsAtom()
    const alreadyExists = selectedNfts.find((n) => n.id === nft.id)

    if (alreadyExists) {
      removeNft(nft.id)
    } else {
      addNft(nft)
    }
  }, "toggleNftSelectionToSell")

  const clearSelection = action(() => {
    selectedNftsAtom.set([])
  }, "clearSelectionToSell")

  return {
    selectedNftsAtom,
    toggleNftSelection,
    clearSelection,
    removeNft,
    addNft,
  }
})
